import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const included = ['🔮 6 Complete Reference Volumes', '🎁 5 Exclusive Bonus Resource Guides', '📚 390+ Pages of Premium Content', '🖨️ Printable Resources & Reference Charts', '✨ Tarot, Reiki, Chakras, Pendulum & More'];
export function PricingPack() {
  return <section className="w-full bg-mist px-4 py-12 sm:py-14" data-id="element-160" data-mp="15ed9fdhlc6p5">
      <Reveal className="mx-auto max-w-[440px]" data-id="element-161" data-mp="1t2wm057ob5n1">
        <div id="complete-package" className="scroll-mt-4 overflow-hidden rounded-2xl border border-amber/50 bg-surface shadow-elevated" data-id="element-162" data-mp="1t47ps514cde5">
          <div className="bg-navy px-4 py-2.5 text-center text-[10px] font-bold uppercase tracking-[0.1em] text-amber" style={{
          color: "#080808",
          backgroundColor: "#F8E8C9",
          backgroundImage: "none"
        }} data-id="element-163" data-mp="1k2zy45t3yat1">
            🧘 Complete Package — One-Time Payment — Lifetime Access
          </div>

          <div className="px-6 py-7 text-center sm:px-8" data-id="element-164" data-mp="cp6e0ndfnx84">
            <h2 className="font-serif text-3xl leading-none text-navy" data-id="element-165" data-mp="cqptibr9m48u">Energy Healing System™</h2>

            <div className="mt-6 rounded-xl border border-navy/10 bg-mist px-5 py-5 text-left" data-id="element-166" data-mp="hw0nk9c1wvnc">
              <p className="text-center text-[10px] font-bold uppercase tracking-[0.14em] text-amber" data-id="element-167" data-mp="cxyxh4g7jw2d">
                📦 Everything You Get Instantly
              </p>
              <ul className="mt-3.5 space-y-2 text-sm font-medium leading-snug text-navy" data-id="element-168" data-mp="muby6ma67a6m">
                {included.map(item => <li key={item} data-id="element-169" data-mp="10t1x87gjvjxm">{item}</li>)}
              </ul>
            </div>

            <p className="mt-6 text-sm text-slate" data-id="element-170" data-mp="vw1qdubvmd5g">
              Total Value: <span className="font-semibold text-navy line-through" data-id="element-171" data-mp="vtfgvp5fdnkl">$102 USD</span>
            </p>
            <span className="mt-2 inline-block rounded-full border border-yellow-500 bg-[#F4B400] px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.08em] text-yellow-950" data-id="element-172" data-mp="1alzb20alkkpw">
              You Save $75 USD
            </span>

            <div className="mt-4 font-serif text-7xl leading-none text-navy" data-id="element-173" data-mp="1em9mhsh5s3c5">
              $27<span className="align-super text-2xl" data-id="element-174" data-mp="c8lk9is2rruj">USD</span>
            </div>
            <p className="mt-2 text-xs leading-5 text-slate" data-id="element-175" data-mp="c6ijq4taqgbk">
              One-time payment · No hidden fees · Instant digital access
            </p>

            <div className="mt-5" data-id="element-176" data-mp="l7yu4ck42ifs">
              <CTAButton href="https://tarot-reiki-chakra.impultienda.ar/checkout" pulse size="large" data-id="element-177" data-mp="l6x7rbxna9ir">
                GET INSTANT ACCESS
              </CTAButton>
            </div>

            <p className="mt-4 border-t border-navy/10 pt-4 text-[11px] leading-5 text-slate" data-id="element-178" data-mp="uybbxx0jjxi8">
              🔒 Secure Payment · 💳 Card · 🌎 Local Currency &amp; Payment Options · ⚡ Instant Access
              · ∞ Lifetime Access
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}